import { IoMdCheckmarkCircleOutline, IoMdCloseCircleOutline } from 'react-icons/io';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
	setBillingType,
	setPlan,
} from '../../../store/reducers/subscriptionSlice/subscriptionSlice';

const PLAN_HIERARCHY = { free: 0, starter: 1, professional: 2, enterprise: 3 };

const PricingCard = ({ plan, billing, currentRazorpayPlanId, currentPlanKey, onOpenFreeModal, onSelectPlan }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const selectedBilling = plan?.billing?.find((item) => item.period === billing);
	const isCurrentPlan = currentRazorpayPlanId != null &&
		plan?.billing?.some((b) => b.razorpay_plan_id === currentRazorpayPlanId);
	const currentLevel = currentPlanKey != null ? (PLAN_HIERARCHY[currentPlanKey] ?? -1) : -1;
	const thisLevel = PLAN_HIERARCHY[plan?.key] ?? -1;
	const isUpgrade = currentPlanKey != null && !isCurrentPlan && thisLevel > currentLevel;
	const isDowngrade = currentPlanKey != null && !isCurrentPlan && thisLevel < currentLevel;

	const getButtonText = () => {
		if (isCurrentPlan) return 'Current Plan';
		return plan?.key === 'professional'
			? 'Go Professional'
			: plan?.key === 'enterprise'
				? 'Go Enterprise'
				: 'Get Started';
	};

	const handleSelectPlan = async () => {
		try {
			if (isCurrentPlan) return;
			if (plan?.key?.includes('free')) {
				onOpenFreeModal(plan);
				return;
			}

			if (currentPlanKey != null && onSelectPlan) {
				onSelectPlan(plan, isDowngrade ? 'downgrade' : 'upgrade');
				return;
			}

			const payload = {
				id: plan?._id,
				key: plan?.key,
				title: plan?.name,
				description: plan?.meta?.description,
				billing: plan?.billing || [],
			};

			dispatch(setPlan(payload));
			dispatch(setBillingType(billing));
			navigate(`/checkout?plan=${plan.key}&billing=${billing}&step=billing-details`);
		} catch (error) {
		}
	};

	return (
		<div className={`pricing-card ${isCurrentPlan ? 'current-plan' : ''}`}>
			{isCurrentPlan && <div className="current-badge">Current Plan</div>}
			{isDowngrade && <div className="current-badge">Downgrade Plan</div>}
			{isUpgrade && <div className="current-badge">Upgrade Plan</div>}

			<h5 className="title">{plan?.name}</h5>
			<p className="desc">{plan?.meta?.description}</p>

			<div className="price">
				{plan?.custom ? (
					<p className="contact">Contact Us</p>
				) : (
					<div className="price-main">
						<span className="currency">₹</span>
						<span className="amount">{selectedBilling?.amount_in_rupees ?? 0}</span>
						<span className="duration">/{billing === 'monthly' ? 'Month' : 'Year'}</span>
					</div>
				)}
			</div>

			<div className="features-wrapper">
				<ul className="features">
					{plan?.display_features?.map((item, i) => {
						const isObject = typeof item === 'object' && item !== null;
						const label = isObject ? item.label : item;
						const display = isObject ? item.display : null;
						const available = isObject ? item.available : true;

						return (
							<li key={i} style={{ opacity: available ? 1 : 0.5 }}>
								{available ? (
									<IoMdCheckmarkCircleOutline className="icon" style={{ color: '#68C230' }} />
								) : (
									<IoMdCloseCircleOutline className="icon" style={{ color: '#dc3545' }} />
								)}
								<span>
									{display && display !== '✓' && display !== '✗'
										? `${display} ${label}`
										: label
									}
								</span>
							</li>
						);
					})}
				</ul>
			</div>

			<div className="btn-group-custom">
				<button
					onClick={handleSelectPlan}
					className={`btn mt-0 w-100 ${isCurrentPlan ? 'btn-disabled me-2' : isDowngrade ? 'btn-primary' : 'btn-primary'}`}
					disabled={isCurrentPlan}
				>
					{getButtonText()}
				</button>
				<Link
					to="https://pharmnex-app.vercel.app/pricing"
					className="btn btn-primary w-100 mt-0"
				>
					Learn More
				</Link>
			</div>
		</div>
	);
};

export default PricingCard;